// React ErrorBoundary, шлёт ошибки рендера в ELS с component stack.

import { Component, type ReactNode, type ErrorInfo } from 'react';
import { reportError } from '../lib/els';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportError(error, {
      componentStack: info.componentStack,
      reactBoundary: true,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div style={{ padding: 32, textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
            <h2 style={{ marginBottom: 12 }}>Произошла ошибка</h2>
            <p style={{ color: '#666', marginBottom: 16 }}>
              {this.state.error?.message ?? 'Неизвестная ошибка'}
            </p>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              style={{
                padding: '8px 16px', borderRadius: 8, border: '1px solid #ccc',
                background: '#fff', cursor: 'pointer',
              }}
            >
              Попробовать снова
            </button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
